import AppLink from '@/components/common/AppLink';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';
import { avatarBg } from '@/functions/formats';
import BlogSearch from '../../blog/blogsContent/BlogSearch';
import { vehicle_fine_path } from '@/api/global';

const links = [
  {
    title: 'استعلام خلافی',
    text: 'خلافی خودرو را آنلاین ببینید',
    href: vehicle_fine_path,
    icon: <MainIcons.documentIcon fill="#fff" />,
    gradient: 'orange',
    bg: avatarBg(0),
  },
  {
    title: 'برندهای خودرو',
    text: 'همهٔ برندها و مدل‌ها',
    href: '/brands',
    icon: <MainIcons.carIcon fill="#fff" />,
    gradient: 'blue',
    bg: avatarBg(1),
  },
  {
    title: 'سرویس‌های کارا',
    text: 'سرویس‌ها و خدمات خودرو',
    href: '/allServices',
    icon: <MainIcons.notifIcon fill="#fff" />,
    gradient: 'purple',
    bg: avatarBg(2),
  },
  {
    title: 'بلاگ کارا',
    text: 'مقالات و راهنماهای خودرو',
    href: '/blogs',
    icon: <MainIcons.ChatIcon fill="#fff" />,
    gradient: 'green',
    bg: avatarBg(3),
  },
];
// ${styles[item.gradient]
export default function NotFoundContent({ locale, messages }: { locale?: string; messages?: any }) {
  return (
    <main className={styles.main}>
      <div className={styles.glow} />

      <div className={styles.content}>
        <div className={styles.codeWrapper}>
          <span className={styles.code}>404</span>

          <span className={styles.badge}>
            <MainIcons.carIcon width="34px" height="34px" />
          </span>
        </div>

        <h1 className={styles.title}>به نظر می‌رسد این صفحه از جاده خارج شده!</h1>

        <p className={styles.description}>
          صفحه‌ای که دنبالش بودید پیدا نشد یا جابه‌جا شده است. نگران نباشید — از مسیرهای زیر به مقصد
          می‌رسید.
        </p>

        <BlogSearch
          page="/search"
          className={`${styles.search}`}
          placeholder="جستجو در کارا…"
          buttonClassName={`${styles.btn} ${styles.primaryBtn}`}
          searchKey={'q'}
          // affix={<></>}
          // setPageNumber={setPageNumber}
        />

        <div className={styles.actions}>
          <AppLink href="/" className={`${styles.btn} ${styles.primaryBtn}`}>
            <MainIcons.homeIcon fill="#fff" />
            بازگشت به خانه
          </AppLink>

          <a href="/contactUs" className={`${styles.btn} ${styles.secondaryBtn}`}>
            تماس با پشتیبانی
          </a>
        </div>

        <div className={styles.linksSection}>
          <div className={styles.linksTitle}>شاید دنبال یکی از این‌ها بودید</div>

          <div className={styles.grid}>
            {links.map((item, index) => (
              <AppLink key={index} href={item?.href} className={styles.card}>
                <div
                  style={{ background: item?.bg }}
                  className={`${styles.icon} 
       

                }`}
                >
                  {item.icon}
                </div>

                <div className={styles.info}>
                  <div className={styles.cardTitle}>{item.title}</div>

                  <div className={styles.cardText}>{item.text}</div>
                </div>

                <span className={styles.arrow}>
                  <MainIcons.arrowLongIcon />
                </span>
              </AppLink>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}
